import { post } from './utilitiesController';

// Create a new participant for an incubation
export const createParticipant = async (data) => {
  return await post('api/participants/create', data, true);
};

// Get all participants for a specific incubation
export const getParticipants = async (data) => {
  return await post(`api/participants/list`, data, true);
};

// Update a participant
export const updateParticipant = async (participantId, data) => {
  console.log('updateParticipant', participantId, data);
  return await post(`api/participants/${participantId}`, data, true);
};

// Get participant prior values for a specific pet
export const getParticipantPriorValues = async (petId) => {
  return await post('api/participants/get_participant_prior_values', { pet_id: petId }, true);
};

// Get a single participant by pet_incubation_id (for /participant-details screen)
export const getParticipantByPetIncubationId = async (petIncubationId) => {
  return await post('api/participants/get_by_pet_incubation_id', { pet_incubation_id: petIncubationId }, true);
};

// Export all participants for a specific incubation (for CSV download)
export const exportAllParticipants = async (data) => {
  return await post('api/participants/export_all', data, true);
};

// Delete multiple participants
export const deleteParticipants = async (data) => {
  return await post('api/participants/delete', data, true);
};

// Send a single survey email to the pet parent of a participant
export const sendParticipantSurvey = async (data) => {
  return await post('api/participants/send_survey', data, true);
};

export default {
  createParticipant,
  getParticipants,
  updateParticipant,
  getParticipantPriorValues,
  getParticipantByPetIncubationId,
  exportAllParticipants,
  deleteParticipants,
  sendParticipantSurvey
};
